let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eAJpn")).then(() => parcelRequire('lGJG2'));